import { api } from 'cssapi'
import styled from 'styled-components'
import linkProps from '../../styles/mixins/linkProps'
import BaseLink from './BaseLink'

const Button = styled(BaseLink)`
  ${linkProps(`c:textInverted`, `c:highlight`)};
  font-weight: normal;
  display: block;
  ${api({
    color: `c:textInverted`,
    backgroundColor: `c:backgroundInverted`,
  })};
`

export default Button



// WEBPACK FOOTER //
// ./src/components/shared/links/ButtonLink.js